import { FormattedMessage } from 'react-intl';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import classNames from 'classnames';

type CategoryFilterProps<T> = {
    categories: T[];
    categoryDefinition: { category: T; labelId: string }[];
    setCategories: (categories: T[]) => void;
};

export const CategoryFilter = <T,>(props: CategoryFilterProps<T>) => {
    const handleSelect = (selected: T) => {
        const current = props.categories;

        const newCategories = current.includes(selected)
            ? current.filter((category) => category !== selected)
            : [...current, selected];

        props.setCategories(newCategories);
    };

    return (
        <div className="margin-top-20">
            <label htmlFor="category-filter">
                <FormattedMessage id="outboundOrderBook.export.categoryFilter" />
            </label>
            <div className="display-flex border rounded-left rounded-right" id="category-filter">
                {props.categoryDefinition.map((definition, index) => {
                    const borderConfig =
                        index + 1 === props.categoryDefinition.length ? '' : 'border border-right-only';
                    return (
                        <Checkbox
                            key={index}
                            onChange={() => handleSelect(definition.category)}
                            checked={props.categories.includes(definition.category)}
                            custom
                            className={classNames(
                                'padding-15 flex-basis-100pct user-select-none hover-bg-highlight-decent',
                                borderConfig,
                            )}
                        >
                            <div className="checkbox-text-wrapper display-flex justify-content-between">
                                <div className="margin-right-15">
                                    <FormattedMessage id={definition.labelId} />
                                </div>
                                <div className="checkbox-text" />
                            </div>
                        </Checkbox>
                    );
                })}
            </div>
        </div>
    );
};
